import styled from "styled-components";
import { Materialize } from "~/styles/materializeGrid";
import { Colors } from "~/config/Colors";

export const Container = styled(Materialize)`
  width: 100%;
  max-width: 100%;
`;

export const FlexDiv = styled.div`
  display: flex;

  .wrapper-input {
    margin: 0 0.25rem;
    width: 100%;
  }

  .btn-search {
    display: flex;

    align-items: center;

    justify-content: center;
    width: 3.325rem;
    height: 2.5rem;
    margin-left: 1rem;
    border: none;
    outline: none;
    padding: 0 0.5rem;
    background-color: ${Colors.bgButton1};
    color: ${Colors.ftColor4};
    border-radius: 0.5rem;
  }

  .btn-search:active {
    transform: translateY(0.3em);

    box-shadow: none;
  }
`;
